import { combineReducers } from 'redux';
import { FETCHING_SOURCE_OF_INCOME, GET_SOURCE_OF_INCOME, POST_SOURCE_OF_INCOME, SOURCE_OF_INCOME_SAVE_ERROR } from '../actions/source-of-income';
const initialState = {
  loaded: false,
  fetching: false
};
const fetch = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case GET_SOURCE_OF_INCOME:
      return {
        loaded: true,
        fetching: false,
        sourceOfIncome: action.sourceOfIncome
      };
    case FETCHING_SOURCE_OF_INCOME:
      return {
        loaded: false,
        fetching: true
      };
    default:
      return state;
  }
};
const initialSubmitState = {
  submitted: false,
  error: false
};

// eslint-disable-next-line default-param-last
const submit = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialSubmitState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case POST_SOURCE_OF_INCOME:
      return {
        submitted: true,
        error: false
      };
    case SOURCE_OF_INCOME_SAVE_ERROR:
      return {
        submitted: false,
        error: true
      };
    default:
      return state;
  }
};
export default combineReducers({
  fetch,
  submit
});